import { LucideIcon } from "lucide-react";
import { motion } from "framer-motion";

interface StatCardProps {
  icon: LucideIcon;
  iconColor: string;
  title: string;
  value: string | number;
  description: string;
  gradientFrom: string;
  gradientTo: string;
  delay?: number;
}

export const StatCard = ({
  icon: Icon,
  iconColor,
  title,
  value,
  description,
  gradientFrom,
  gradientTo,
  delay = 0
}: StatCardProps) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className="w-full"
    >
      <motion.div 
        whileHover={{ scale: 1.02 }}
        className={`p-4 rounded-lg bg-gradient-to-br from-${gradientFrom} to-${gradientTo} shadow-lg hover:shadow-xl transition-all duration-300`}
      >
        <div className="flex items-center gap-2 mb-2">
          <Icon className={`h-5 w-5 ${iconColor}`} />
          <h3 className="font-semibold">{title}</h3>
        </div>
        <p className="text-2xl font-bold">{value}</p>
        <p className="text-sm text-muted-foreground">{description}</p>
      </motion.div>
    </motion.div>
  );
};